import { PATHS } from './constants';
import { PERMISSIONS } from '../teams/constants/permissions';

const BillingNavigationConfig = {
  id: 'billing',
  title: 'Billing',
  translate: 'BILLING',
  type: 'item',
  icon: 'billing:nav-icon',
  url: PATHS.BILLING,
  auth: [PERMISSIONS.GetClientSubscription.value, PERMISSIONS.ClientSubscriptionAll.value],
};

export default BillingNavigationConfig;
